/* ===================================================================
   Z23-001 anice_zerotwothree — Scroll reveal (GSAP + ScrollTrigger)
   gsap.min.js / scrolltrigger.min.js（テーマ同梱）を前提。
   .z23-reveal(カーテン: 下から迫り上がる) / .z23-fade(フェード) を
   スクロール連動で1要素ずつreveal。発火は「下から1/3（top 67%）」。

   [data-z23-stagger] 内の .z23-reveal は、そのグループがビューに入ったら
   1行ずつ順番（stagger）にreveal。単体revealからは除外。

   ★ CSS側では隠さない。GSAP が読めた時だけ gsap.from が初期状態(hidden)を
     JSでセットする → GSAP/本JSが読めない場合はテキストがそのまま表示される
     （消えないフェイルセーフ）。本ファイルは defer で gsap/scrolltrigger の後に実行。
   =================================================================== */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!window.gsap || !window.ScrollTrigger || reduce) return;

  gsap.registerPlugin(ScrollTrigger);

  /* stagger グループ: 中の .z23-reveal を1行ずつ順番に */
  gsap.utils.toArray('[data-z23-stagger]').forEach(function (group) {
    var lines = group.querySelectorAll('.z23-reveal');
    if (!lines.length) return;
    gsap.from(lines, {
      yPercent: 110,
      duration: 1.2,
      ease: 'power4.out',
      stagger: 0.15,
      scrollTrigger: { trigger: group, start: 'top 90%' }
    });
  });

  /* 単体 reveal（staggerグループ内は除外） */
  gsap.utils.toArray('.z23-reveal').forEach(function (el) {
    if (el.closest('[data-z23-stagger]')) return;
    gsap.from(el, {
      yPercent: 110,
      duration: 1.4,
      ease: 'power4.out',
      scrollTrigger: { trigger: el, start: 'top 90%' }
    });
  });

  /* フェード */
  gsap.utils.toArray('.z23-fade').forEach(function (el) {
    gsap.from(el, {
      autoAlpha: 0,
      duration: 1.0,
      ease: 'power2.out',
      scrollTrigger: { trigger: el, start: 'top 90%' }
    });
  });

})();

/* ABOUT: 画像 crop パララックス（TOP z23_philo_img と同方式: rAF + translateY px）
   GSAP非依存。コンテナ overflow:hidden、img は height:140% object-position:top。
   セクションが下→上へ抜ける間、img を translateY 0 → -120px（下部が見えてくる）。 */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var imgs = document.querySelectorAll('.z23_ab_concept_img img, .z23_ab_mission_img img, .z23_ab_company_img img');
  if (!imgs.length) return;
  var pending = false;
  function update() {
    pending = false;
    var viewH = window.innerHeight || document.documentElement.clientHeight;
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var wrap = img.parentElement;
      var rect = wrap.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewH) continue;
      var progress = (viewH - rect.top) / (viewH + rect.height);
      /* 移動量はコンテナ高さ比例（画面幅に依らず隙間なし）。img余剰(160%=+60%)内。 */
      var ty = -progress * rect.height * 0.53;
      img.style.transform = 'translateY(' + ty.toFixed(2) + 'px)';
    }
  }
  window.addEventListener('scroll', function () { if (!pending) { pending = true; requestAnimationFrame(update); } }, { passive: true });
  window.addEventListener('resize', function () { if (!pending) { pending = true; requestAnimationFrame(update); } }, { passive: true });
  update();
})();

/* [data-z23-inview] の動画を画面内で再生 / 画面外で一時停止 */
(function () {
  var vids = document.querySelectorAll('video[data-z23-inview]');
  if (!vids.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else { v.pause(); }
    });
  }, { threshold: 0.25 });
  vids.forEach(function (v) { io.observe(v); });
})();
